import { isNullOrUndefinedOrEmpty } from 'rewire-common';

export function nameObjMap(value: any) {
  return value?.name ?? value ?? '';
}

export function nameObjCompare(x: any, y: any) {
  const v1 = nameObjMap(x);
  const v2 = nameObjMap(y);
  if (!isNullOrUndefinedOrEmpty(v1) && isNullOrUndefinedOrEmpty(v2)) {
    return -1;
  }
  if (isNullOrUndefinedOrEmpty(v1) && !isNullOrUndefinedOrEmpty(v2)) {
   return 1;
 }
  return v1.localeCompare(v2);
}